module.exports = __webpack_public_path__ + "img/グループ 255.5cb4d128.jpg";